import type { HTMLAttributes, ReactNode } from 'react';
import { cx } from '../utils/cx.js';
import styles from './Card.module.css';

export type CardElevation = 'flat' | 'ring' | 'elevated';

export type CardProps = HTMLAttributes<HTMLDivElement> & {
  elevation?: CardElevation;
  padding?: 'sm' | 'md' | 'lg';
  children: ReactNode;
};

const padClass = { sm: styles.paddingSm, md: styles.paddingMd, lg: styles.paddingLg } as const;

export function Card({ elevation = 'ring', padding = 'md', className, children, ...rest }: CardProps) {
  return (
    <div className={cx(styles.card, styles[elevation], padClass[padding], className)} {...rest}>
      {children}
    </div>
  );
}
